import { ThemeProvider } from "@mui/material";
import OverridedThemes from "./mui-themes/ThemeOverrides";
import { useDispatch, useSelector } from "react-redux";
import { loginRedux } from "./redux/login-redux/LoginRedux";
import { useEffect, useLayoutEffect, useState } from "react";
import { getLocalStorageItem } from "./utils/LocalStorage";
import moment from "moment";
import { setError, setSuccessfull, ToasterRedux } from "./redux/toaster-redux/ToasterRedux";
import { ToasterComponent } from "./components/common/toaster-component/ToasterComponent";
import AppRoutes from "./routes/AppRoutes";
import UAParser from 'ua-parser-js';
import { getCookies } from "./utils/Cookies";
import { initGA, logPageView } from "./analytics";
import { useLocation } from "react-router-dom";
import ChatWithUs from "./components/common/chat-with-us/ChatWithUs";
import UnderMaintenance from "./pages/site-under-maintainance/UnderMaintenance";


import { PostHogProvider } from 'posthog-js/react'
import posthog from "posthog-js";


const App = () => {
  // const cachedUserDetails: any = getCookies("userDetails");
  // const loggedInUser: any = JSON.parse(cachedUserDetails);
  const [deviceInfo, setDeviceInfo] = useState({ device: '', os: '', browser: '' });

  const dispatch = useDispatch();

  useEffect(() => {
    const currentHost = window.location.hostname;
  
    const isSekeron = currentHost === 'sekeron.com';
  
    if (isSekeron) {
      posthog.init(process.env.REACT_APP_PUBLIC_POSTHOG_KEY, {
        api_host: 'https://us.i.posthog.com',
        debug: false // disable console logs in prod
      });
  
      posthog.capture('page_view'); // Optional: initial tracking
    } else {
      console.log('🛑 Skipping PostHog tracking on non-sekeron.com domain:', currentHost);
    }
  }, []);

  useEffect(() => {
    const parser = new UAParser();
    const result = parser.getResult();
    setDeviceInfo({
      device: result.device.model || 'Unknown Device',
      os: result.os.name || 'Unknown OS',
      browser: result.browser.name || 'Unknown Browser'
    });
  }, []);

  const actionDispatch = (dispatch: any) => ({
    refreshAuthTokenRequest: (data: any) =>
      dispatch(loginRedux.actions.refreshAuthTokenRequest(data)),
    setToaster: (data: any) => dispatch(ToasterRedux.actions.setToaster(data)),
  });

  const { refreshAuthTokenRequest, setToaster } = actionDispatch(useDispatch());

  const loginReduxState = useSelector((state: any) => state.Login);

  // useEffect(() => {
  //   const dateB = moment(new Date().getTime());
  //   const dateC = moment(new Date(loggedInUser?.loggedInTime)?.getTime());

  //   const timer = setInterval(() => {
  //     if (cachedUserDetails !== undefined) {
  //       if (
  //         moment(
  //           new Date(loggedInUser?.loggedInTime).getTime() +
  //           4 * 60 * 60 * 1000 -
  //           30 * 1000
  //         ).format("hh:mm a") === moment(new Date().getTime()).format("hh:mm a")
  //       ) {
  //         refreshAuthTokenRequest({
  //           userId: loggedInUser?.id,
  //          "deviceId": `${deviceInfo?.os} - ${deviceInfo?.browser}`,
  //         });
  //       } else if (dateB.diff(dateC, "hours") > 4) {
  //         refreshAuthTokenRequest({
  //           userId: loggedInUser?.id,
  //          "deviceId": `${deviceInfo?.os} - ${deviceInfo?.browser}`,
  //         });
  //       }
  //     }
  //   }, 5000);

  //   return () => clearInterval(timer);
  // }, [loginReduxState]);

  useEffect(() => {
    window.addEventListener("offline", (e: any) => checkApplicationStatus(e));
    window.addEventListener("online", (e: any) => checkApplicationStatus(e));
  }, []);

  const checkApplicationStatus = (e: any) => {
    if (e.type === "offline") {
      const response = {
        status: 500,
        data: { message: "Connection Error" },
      }
      setToaster({ key: "isApplicationOffline", value: true });
      dispatch(setError(response));
    } else if (e.type === "online") {
      const OnlineResponse = {
        status: 200,
        data: { message: "Back Online" },
      }
      dispatch(setSuccessfull(OnlineResponse));
      setToaster({ key: "isApplicationOffline", value: false });
    }
  };

  useLayoutEffect(() => {
    if (process.env.REACT_APP_SEKERON_DEV_MODE === "QA") {
      document.title = ""
    } else {
      document.title = "Sekeron - Online Platform With Infinite Collaborative Opportunities"
    }
  }, [])

  useEffect(() => {
    if (window.location.hostname !== "localhost") {
      initGA(); // Initialize GA with the Measurement ID
      logPageView(); // Log the first page load
    }
  }, [window.location.hostname]);

  // Track page views on route change
  const location = useLocation();
  useEffect(() => {
    if (window.location.hostname !== "localhost") {
      logPageView(); // Log pageview for each route change
    }
  }, [location]);

  return (
    <ThemeProvider theme={OverridedThemes}>
      {/* <UnderMaintenance /> */}
      <PostHogProvider client={posthog}>
        <ToasterComponent>
          <AppRoutes />
        </ToasterComponent>
        {/* <ChatWithUs /> */}
      </PostHogProvider>
    </ThemeProvider>
  );
};

export default App;
